import React from "react";
import SalesDashboard from "Containers/SalesTracking/SalesDashboard";
import VisitsPage from "Containers/SalesTracking/VisitsPage";
import VisitPlanner from "Containers/SalesTracking/VisitPlanner";
import UnplannedMap from "Containers/SalesTracking/UnplannedMap";
import VisitsMap from "Containers/SalesTracking/VisitsMap";
import PersonsPage from "Containers/SalesTracking/PersonsPage";
import SalesTrack from "Containers/SalesTracking/SalesTrack";

const SalesTrackingActions = {
  sales_dashboard: {
    view: {
      codenames: [],
      action_code: "visible_sales_dashboard_view",
      is_superuser_action: false,
      name: "View Sales Dashboard",
      label: "Dashboard",
      action: "sub-menu",
      url: "/sales-dashboard",
      component: <SalesDashboard />,
      permission_needed: true,
    },
    name: "Sales Dashboard",
    type: "Sales & Support",
  },
  sales_visits: {
    view: {
      codenames: [],
      action_code: "visible_sales_visits_view",
      is_superuser_action: false,
      name: "View Sales Visits",
      label: "Visits",
      action: "sub-menu",
      url: "/sales/visits",
      component: <VisitsPage />,
      permission_needed: true,
    },
    name: "Sales Visits",
    type: "Sales & Support",
  },
  sales_my_visits: {
    view: {
      codenames: [],
      action_code: "visible_sales_my_visits_view",
      is_superuser_action: false,
      name: "View Sales My Visits",
      label: "My Visits",
      action: "sub-menu",
      url: "/sales/my-visits",
      component: <VisitsPage />,
      permission_needed: true,
    },
    name: "Sales My Visits",
    type: "Sales & Support",
  },
  sales_visit_planner: {
    view: {
      codenames: [],
      action_code: "visible_sales_visit_planner_view",
      is_superuser_action: false,
      name: "View Visit Planner",
      label: "Visit Planner",
      action: "sub-menu",
      url: "/sales/visit-planner",
      component: <VisitPlanner />,
      permission_needed: true,
    },
    name: "Visit Planner",
    type: "Sales & Support",
  },
  sales_unplanned: {
    view: {
      codenames: [],
      action_code: "visible_sales_unplanned_view",
      is_superuser_action: false,
      name: "View Unplanned Visits",
      label: "Unplanned",
      action: "sub-menu",
      url: "/sales/unplanned",
      component: <UnplannedMap />,
      permission_needed: true,
    },
    name: "Unplanned",
    type: "Sales & Support",
  },
  sales_visits_map: {
    view: {
      codenames: [],
      action_code: "visible_sales_visits_map_view",
      is_superuser_action: false,
      name: "View Sales Map",
      label: "Sales Map",
      action: "sub-menu",
      url: "/sales/visits-map",
      component: <VisitsMap />,
      permission_needed: true,
    },
    name: "Sales Map",
    type: "Sales & Support",
  },
  sales_persons: {
    view: {
      codenames: [],
      action_code: "visible_sales_persons_view",
      is_superuser_action: false,
      name: "View Sales Persons Expenses",
      label: "Sales Persons Expenses",
      action: "sub-menu",
      url: "/sales/persons",
      component: <PersonsPage />,
      permission_needed: true,
    },
    name: "Sales Persons Expenses",
    type: "Sales & Support",
  },
  sales_track: {
    view: {
      codenames: [],
      action_code: "visible_sales_track_view",
      is_superuser_action: false,
      name: "View Sales Track",
      label: "Sales Track",
      action: "sub-menu",
      url: "/sales/track",
      component: <SalesTrack />,
      permission_needed: true,
    },
    name: "Sales Track",
    type: "Sales & Support",
  },
  sales_my_track: {
    view: {
      codenames: [],
      action_code: "visible_sales_my_visits_view",
      is_superuser_action: false,
      name: "View Sales My Visits",
      label: "My Sales Track",
      action: "sub-menu",
      url: "/sales/my-track",
      component: <SalesTrack />,
      permission_needed: true,
    },
    name: "My Sales Track",
    type: "Sales & Support",
  }
};

export default SalesTrackingActions;